package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.radar.options.FontOptions
import pl.decks.chartjs.style.FontStyle
import pl.decks.chartjs.style.FontWeightChart

@RadarDsl
class FontScope {
    var size: Int? = null
    var family: String? = null
    private var weight: FontWeightChart? = null
    var style: FontStyle? = null

    fun weight(value: Int) {
        weight = FontWeightChart.Numbered(value)
    }
    fun weight(name: FontWeightChart.Weight) {
        weight = FontWeightChart.Named(name)
    }

    internal fun build() = FontOptions(
        size = size,
        family = family,
        weight = weight,
        style = style,
    )
}
